// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import { parseDuration } from '../../../../../../lib/utility';
import { Chapter } from '../../../../../../types/Model';
import Modules from './Modules';
import { S } from './styles';

interface ChapterProps {
  courseId: number;
  chapters: Chapter[];
  chapterIndex: number;
  defaultIsOpen?: boolean;
}

const ChapterComponent: React.FC<ChapterProps> = (props):JSX.Element => {
  const {
    courseId,
    chapters,
    chapterIndex,
    defaultIsOpen = true,
  } = props;
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const {
    name,
    totalDuration = 0,
  } = chapters[chapterIndex];

  const handleToggle = () => {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <S.HeaderContainer>
        <S.HeaderTitle>{name}</S.HeaderTitle>
        <S.RightColumn>
          <S.DurationText>{parseDuration(totalDuration).auto}</S.DurationText>
          <S.ToggleButton onClick={handleToggle} isOpen={isOpen} />
        </S.RightColumn>
      </S.HeaderContainer>
      <S.CollapseTransition visible={isOpen}>
        <Modules courseId={courseId} chapters={chapters} chapterIndex={chapterIndex} />
      </S.CollapseTransition>
    </>
  );
}

export { ChapterComponent as default };
